import React, { useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdClose } from "react-icons/md";
import { ImSun } from "react-icons/im";
import { BsFillMoonFill } from "react-icons/bs";

export default function Navbar({ changeTheme, currentTheme }) {
  const [navState, setNavState] = useState(false);
  const html = document.querySelector("html");
  html.addEventListener("click", () => setNavState(false));

  return (
    <nav>
      <div className="container py-3 mx-3">
        <div className="brand">
          <span>Arka Przymierza</span>
          <span className="dot">.</span>
        </div>
        <div className="links-container" onClick={(e) => e.stopPropagation()}>
          <div className="toggle">
            {navState ? (
              <MdClose onClick={() => setNavState(false)} />
            ) : (
              <GiHamburgerMenu
                onClick={(e) => {
                  e.stopPropagation();
                  setNavState(true);
                }}
              />
            )}
            <div onClick={changeTheme}>
              {currentTheme === "dark" ? (
                <ImSun className="sun" />
              ) : (
                <BsFillMoonFill className="moon" />
              )}
            </div>
          </div>
          <div className={`links ${navState ? "responsive-toggle" : ""}`}>
            <ul>
              <li>
                <a href="#"> Start</a>
              </li>
              <li onClick={() => setNavState(false)}>
                <a href="#miejsca"> Miejsca</a>
              </li>
              <li onClick={() => setNavState(false)}>
                <a href="#znaczenie"> Znaczenie</a>
              </li>
              <li onClick={() => setNavState(false)}>
                <a href="#zawartość"> Zawartość</a>
              </li>
              <li onClick={() => setNavState(false)}>
                <a href="#losy"> Losy</a>
              </li>
              <li onClick={() => setNavState(false)}>
                <a href="#przybytek"> Przybytek</a>
              </li>
              <li onClick={() => setNavState(false)}>
                <a href="#kapłani"> Kapłani</a>
              </li>
              <li onClick={changeTheme} className="color-mode">
                {currentTheme === "dark" ? (
                  <ImSun className="sun" />
                ) : (
                  <BsFillMoonFill className="moon" />
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
}
